import Api from '~/config/Api'
const endpoint = Api.packages

export default {
  async book (
    slug,
    {
      packageId,
      contactInfo,
      passengers,
      hasInsurance,
      hasMatchInsurance,
      hasAcceptedExtraordinaryConditions,
      comment
    }
  ) {
    const preorderEndpoint = endpoint + '/' + slug + '/preorder'
    const { data } = await useApi(preorderEndpoint, {
      method: 'POST',
      body: {
        packageId,
        contactInfo,
        passengers,
        extra: {
          hasInsurance,
          hasMatchInsurance,
          hasAcceptedExtraordinaryConditions,
          comment
        }
      }
    })

    return data
  }
}
